// Helpers to build JSON-LD schemas for per-page injection via <Seo>.

const SITE = 'https://barcabrero.com';

/**
 * Build a BreadcrumbList schema.
 * @param {Array<{name: string, path: string}>} items — ordered crumbs (without "Inicio" — added automatically)
 */
export function breadcrumb(items) {
  const all = [{ name: 'Inicio', path: '/' }, ...items];
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: all.map((c, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: c.name,
      item: `${SITE}${c.path}`,
    })),
  };
}

/** AboutPage schema referencing the bar. */
export function aboutPage({ name, description, path }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name,
    description,
    url: `${SITE}${path}`,
    inLanguage: 'es',
    mainEntity: { '@id': `${SITE}/#bar` },
    mentions: {
      '@type': 'Person',
      name: 'Marcos Argumosa',
      jobTitle: 'Propietario y maestro de barra',
      worksFor: { '@type': 'Organization', name: 'Rumoroso56, S.L.' },
    },
  };
}

/** ContactPage schema. */
export function contactPage({ description, path }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    name: 'Cómo llegar y horarios — Bar Cabrero',
    description,
    url: `${SITE}${path}`,
    inLanguage: 'es',
    mainEntity: { '@id': `${SITE}/#bar` },
  };
}

/** ItemList schema for the 12 gildas. */
export function gildasItemList(gildas) {
  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Las 12 Gildas del Bar Cabrero',
    itemListOrder: 'https://schema.org/ItemListOrderAscending',
    numberOfItems: gildas.length,
    itemListElement: gildas.map((g, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      item: {
        '@type': 'MenuItem',
        name: g.name,
        description: g.desc,
        image: `${SITE}${g.img}`,
      },
    })),
  };
}
